import CompanyDetails from "@/pages/CompanyDetails";
import {selectedCompanyIdAtom} from "@/store/jotaiAtoms";
import {createFileRoute} from "@tanstack/react-router";
import {getDefaultStore} from "jotai";

export const Route = createFileRoute("/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/")({
  component: CompanyDetails,
  params: {
    parse: raw => ({
      agencyId: +raw.agencyId,
      companyId: +raw.companyId,
    }),
    stringify: params => ({
      agencyId: params.agencyId?.toString(),
      companyId: params.companyId?.toString(),
    }),
  },
  loader: ({params}) => {
    getDefaultStore().set(selectedCompanyIdAtom, params.companyId);
  },
});
